/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const BudgetInput = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;
export const ButtonsWrap = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-around;
  margin-top: 4px;
`;

export const ErrorWrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${Palette.Red._600};
  padding: 4px 0;
  margin-bottom: 2px;

  span {
    word-break: break-word;
  }
`;
